<template>
  <generic-modal :title="$t('period')" ref="generic_modal">
    <div class="title is-3 has-text-primary">
      {{ enterprise.name }}
    </div>
    <div class="columns">
      <div class="column is-one-third">
        <div class="field">
          <label class="label">{{ $t("name") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.name" />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("number of levels") }}</label>
          <div class="control has-icons-left">
            <input
              class="input"
              type="text"
              v-model="meta.settings.number_of_levels"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-list"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("digits by level") }}</label>
          <div class="control has-icons-left">
            <input
              class="input"
              type="text"
              v-model="meta.settings.digits_by_level"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-hashtag"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "EnterpriseModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: {
        settings: {},
      },
      error: "",
      enterprise: {},
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name;
    },
  },
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/accounting/period", { uuid: uuid })
        .then((period) => {
          // console.log(period);
          v.meta = period;
          v.enterprise = period.accounting_enterprise;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    show_modal(enterprise) {
      let v = this;
      v.set_initial_state();
      v.enterprise = enterprise;
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta, enterprise_uuid: v.enterprise.uuid };
      if (!v.meta.uuid)
        put("/accounting/period", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/accounting/period", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.enterprise = {};
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
